import AISparkle from "../../assets/images/AISparkle.svg";
import CSS from "./styles.module.css";

const HeroText = ({ result }) => {
	return (
		<div className={`${CSS.HeroText} ${result === 3 ? CSS.HeroText2 : ""}`}>
			<h1 className={`${CSS.Text} ${result === 3 ? CSS.Text2 : ""}`}>
				{result === 3
					? "Here's your Top Interview Questions"
					: "Free AI Interview Question Generator"}
				<img src={AISparkle} alt="Free Job description Generator" />
			</h1>
			<font>
				Get tailored interview questions for any job, skill level, or industry
				in seconds.
			</font>
		</div>
	);
};

export default HeroText;
